import AgendaItemOrganizer from "@/domain/entities/agenda/AgendaItemOrganizer";
import { AgendaItemOrganizer as AgendaItemOrganizerSDK } from "@cs_teamwaydev/mailvista-sdk_react";

const agendaItemOrganizerToDomainMapper = (
    agendaItemOrganizer: AgendaItemOrganizerSDK,
): AgendaItemOrganizer =>
    new AgendaItemOrganizer({
        emailAddress: agendaItemOrganizer.emailAddress,
    });

export default agendaItemOrganizerToDomainMapper;
